import { render, staticRenderFns } from "./SingleProgressbarSetCard.vue?vue&type=template&id=18564fb0&"
import script from "./SingleProgressbarSetCard.vue?vue&type=script&lang=js&"
export * from "./SingleProgressbarSetCard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/partial/cards/single-progressbar-set-card.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports